import React, { useState } from "react";
import Reproducibility_table from "./reproducibility_table/Reproducibility_table";
import Reproducibility_Form from "./reproducibility_Form/Reproducibility_Form";

function Reproducibility() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <Reproducibility_Form onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <Reproducibility_table/>
        </div>
      )}
    </>
  );
}

export default Reproducibility;
